import Vue from 'vue'
import Router from 'vue-router'
import Authorized from '@/pages/Authorized.vue'
import Unauthorized from '@/pages/Unauthorized.vue'
import * as utils from '@/utils'
import store from '../vuex'
import routers from '@/pages/authorized/router'
// routes

Vue.use(Router)
let router = new Router({
  routes: [
    {
      name: 'login',
      path: '/login',
      component: Unauthorized
    },
    {
      name: 'authorized',
      path: '/',
      redirect: {
        name: 'dashboard'
      },
      component: Authorized,
      children: [...routers]
    }
  ]
})

router.beforeEach((to, from, next) => {
  let user = utils.getStorage('pvsuser')
  if (to.name !== 'login') {
    
    if (user) {
     
      if (to.path !== '/changepassword' && to.path !== '/order') {
        
        if (store.state.userinfo && store.state.userinfo.changepwd) {
          next('/changepassword')
        }else if (store.state.userinfo && store.state.userinfo.adminlevel==2) {
          if(to.name !== 'order' && to.name !== 'orderDetail' && to.name !== 'product' && to.name !== 'productDetail' && to.name !== 'vechainorder' && to.name !== 'vechainorderCreate') {
            next('/order?page=1')
          } else {
            next()
          }
        }else if (store.state.userinfo && store.state.userinfo.adminlevel==3) {
          if(to.name !== 'vechainorder' && to.name !== 'vechainorderCreate') {
            next('/vechainorder?page=1')
          } else {
            next()
          }
        }else if (store.state.userinfo && store.state.userinfo.adminlevel==4) {
          if(to.name !== 'order' && to.name !== 'orderDetail') {
            next('/order?page=1')
          } else {
            next()
          }
        }else{
          next()
        } 
      } else {
        next()
      }
    } else {
      next({
        name: 'login'
      })
    }
  } else {
    user ? next('/') : next()
  }
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js